import styled from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { getColor } from '../../../styling/mixins/colors';
import { fontFamily, fontFamilyBold, text } from '../../../styling/mixins/typography';

export const StyledLandscapeProductCard = styled.div`
  display: flex;
  background-color: ${getColor('white')};
  border: 1px solid ${getColor('grey', 200)};
  border-radius: 4px;
  padding: 1.2rem;
  flex-direction: column;
  margin-bottom: 0.4rem;
  ${breakpoint('medium')} {
    flex-direction: row;
  }

  .top-section {
    display: flex;
    flex: 1;
    margin-bottom: 1.6rem;
    ${breakpoint('medium')} {
      margin-bottom: 0;
    }
  }
  .stock-relation-wrapper {
    ${text('small')};
    color: ${getColor('gray', 600)};
    display: flex;
  }
  .stock-status {
    margin-right: 0.8rem;
    display: none;
    ${breakpoint('medium')} {
      display: block;
    }
    svg {
      display: none;
    }
    .stock-status-description {
      ${text('small')};
      color: ${getColor('gray', 600)};
    }
    &--mobile {
      ${text('small')};
      color: ${getColor('gray', 600)};
      display: block;
      margin-top: 0.8rem;
      ${breakpoint('medium')} {
        display: none;
      }
    }
  }
  .buy-button {
    flex-direction: row;

    .quantity-input input {
      ${text('large')}
      padding: 0.8rem 1.2rem;
      max-width: 100%;
    }

    button {
      display: flex;
      align-items: center;
    }
  }

  .image-wrapper {
    background-color: ${getColor('white')};
    max-width: 80px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      aspect-ratio: 1/1;
      object-fit:  contain;
    }
  }

  .information {
    flex: 1;
    padding: 0 1.2rem;
  }

  .overline {
    ${text('medium')}
    color: ${getColor('grey', 500)};
    margin-bottom: 0.2rem;
  }

  .name {
    ${text('medium')}
    display: flex;
    ${fontFamilyBold}
    margin-bottom: 0.6rem;
  }
  .star-rating {
    height: 1.8rem;
    margin-bottom: 0.8rem;
  }
  .description {
    ${text('medium')};
    color: ${getColor('grey', 500)};
    margin-bottom: 0.8rem;
  }
  .priceContainer {
    display: flex;
    gap: 0.5rem;
    align-items: flex-end;
    margin-bottom: 0.8rem;
  }

  .price,
  .from {
    ${text('medium')}
    ${fontFamilyBold}
    margin: 0;
    &.campaign {
      color: ${getColor('primary')};
    }
  }

  .original-price {
    text-decoration: line-through;
    text-decoration-line: line-through;
    ${fontFamily}
    color: ${getColor('gray', 600)};
  }
  .ex-wat {
    text-decoration: none;
    text-decoration-line: none;
    ${text('medium')};
    color: ${getColor('gray', 600)};
  }

  .price {
    ${text('medium')}
    ${fontFamilyBold}
    line-height: 1.2;
  }

  .campaign-price {
    text-decoration: line-through;
    margin-left: 0.8rem;
    ${fontFamily}
    color: ${getColor('grey', 500)};
  }

  .actions {
    display: flex;
    flex-direction: column;
    max-width: 78px;
    gap: 0.8rem;
  }
`;

export const StyledProductTagWrapperLandscape = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-bottom: 0.4rem;
`;
